/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
/**
 * Fair Debt Collection Practices Act (FDCPA) settings
 * rolling_days: number of days to track attempted calls or connected calls for FDCPA compliance
 * Note: connected call (where an agent speaks to a contact) is also considered as one attempt
 * @export
 * @interface FDCPASettings
 */
export interface FDCPASettings {
  /**
   * Number of days to track attempted calls for FDCPA compliance
   * @type {number}
   * @memberof FDCPASettings
   */
  attemptedCallRollingDays?: number;
  /**
   * Number of days to track connected calls for FDCPA compliance
   * @type {number}
   * @memberof FDCPASettings
   */
  connectedCallRollingDays?: number;
  /**
   * FDCPA enabled
   * @type {boolean}
   * @memberof FDCPASettings
   */
  enabled?: boolean;
  /**
   * maximum call attempts within rolling days window
   * @type {number}
   * @memberof FDCPASettings
   */
  maxAttemptedCalls?: number;
  /**
   * maximum connected call attempts within rolling days window
   * @type {number}
   * @memberof FDCPASettings
   */
  maxConnectedCalls?: number;
}

/**
 * Check if a given object implements the FDCPASettings interface.
 */
export function instanceOfFDCPASettings(value: object): value is FDCPASettings {
  return true;
}

export function FDCPASettingsFromJSON(json: any): FDCPASettings {
  return FDCPASettingsFromJSONTyped(json, false);
}

export function FDCPASettingsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): FDCPASettings {
  if (json == null) {
    return json;
  }
  return {
    attemptedCallRollingDays:
      json['attempted_call_rolling_days'] == null
        ? undefined
        : json['attempted_call_rolling_days'],
    connectedCallRollingDays:
      json['connected_call_rolling_days'] == null
        ? undefined
        : json['connected_call_rolling_days'],
    enabled: json['enabled'] == null ? undefined : json['enabled'],
    maxAttemptedCalls:
      json['max_attempted_calls'] == null
        ? undefined
        : json['max_attempted_calls'],
    maxConnectedCalls:
      json['max_connected_calls'] == null
        ? undefined
        : json['max_connected_calls'],
  };
}

export function FDCPASettingsToJSON(value?: FDCPASettings | null): any {
  if (value == null) {
    return value;
  }
  return {
    attempted_call_rolling_days: value['attemptedCallRollingDays'],
    connected_call_rolling_days: value['connectedCallRollingDays'],
    enabled: value['enabled'],
    max_attempted_calls: value['maxAttemptedCalls'],
    max_connected_calls: value['maxConnectedCalls'],
  };
}
